import React, { Component } from 'react'
import { connect } from 'react-redux'

class ButtonContainer extends Component {
  constructor (props) {
    super(props)
    this.state = {
      toggled: false,
    }
  }
  componentWillReceiveProps (nextProps) {
    this.forceUpdate()
  }
  render () {
    if (!this.props.buttons) return false
    if (this.props.siteReducer.isMobile && this.props.buttons.filter(o => !o.hidden).length > 1) {
      return (
        <a className='box-button pull-right' onClick={() => this.setState({ toggled: !this.state.toggled })}><i className='fa fa-fw fa-ellipsis-h' />
          <div className={(this.state.toggled ? 'box-button-dropdown-links' : 'hidden')}>
            {this.props.buttons && this.props.buttons.map((button, index) => {
              if (button.hidden) return null
              return (
                <a key={'ButtonContainer_Button_' + index} onClick={!button.disabled && button.event} disabled={button.disabled} data-tip={button.datatip} className='pull-right box-button'><i className={'fa fa-fw ' + button.icon} /> {button.text ? button.text : ''}</a>
              )
            })}
          </div>
        </a>
      )
    } else {
      return (
        <div className='pull-right'>
          {this.props.buttons && this.props.buttons.map((button, index) => {
            if (button.hidden) return null
            return (
              <a key={'ButtonContainer_Button_' + index} onClick={!button.disabled && button.event} href={button.href} disabled={button.disabled} data-tip={button.datatip} className={'pull-right box-button button-container-button ' + (button.disabled ? 'box-btn-disabled' : '')}>
                {!!button.icon && <i className={'fa fa-fw ' + button.icon} />}
                {!!button.text && <small>{button.text}</small>}
              </a>
            )
          })}
        </div>
      )
    }
  }
}
// eslint-disable-next-line
ButtonContainer = connect(state => state)(ButtonContainer)
export default ButtonContainer



// WEBPACK FOOTER //
// ./src/components/basic/containers/ButtonContainer.js